import { Wrapper } from './styles';

type MainContentProps = {
  children: React.ReactNode;
  hasFooter?: boolean;
  id?: string;
};

const MainContent = ({ id, children, hasFooter = false }: MainContentProps) => (
  <Wrapper hasFooter={hasFooter} id={id}>
    {children}
  </Wrapper>
);

export default MainContent;
